import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-offerbuy',
  templateUrl: './offerbuy.component.html',
  styleUrls: ['./offerbuy.component.css']
})
export class OfferbuyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
